import { useQuery } from "@tanstack/react-query";

import { getFinancialData } from "../services/financials.service";

export const useAllFinancialDataHook = (queryParams: any) =>
  useQuery({
    queryKey: ["financials", queryParams],
    queryFn: () => getFinancialData(queryParams),
  });
